import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import { withTranslation, TRANSLATION_KEYS } from 'LiveBoard/hocs'
import SelectionField from '../SelectionField/SelectionField'
import { FORM_FIELD_TYPES } from 'LiveBoard/components/shared/CallToAction/types/forms/ConfigurableForms/CustomForm/constants'
import { CUSTOM_FORM_FIELD_STATES } from 'LiveBoard/components/shared/CallToAction/types/forms/constants'
import { TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const TYPE_COMPONENT = {
  [FORM_FIELD_TYPES.text]: 'input',
  [FORM_FIELD_TYPES.longText]: 'textarea',
  [FORM_FIELD_TYPES.select]: 'select',
  [FORM_FIELD_TYPES.email]: 'input',
  [FORM_FIELD_TYPES.tel]: 'input',
  [FORM_FIELD_TYPES.hidden]: 'input'
}

const FIELDS_CONFIG = {
  name: {
    className: "first-name"
  },
  last_name: {
    field: "name",
    state: CUSTOM_FORM_FIELD_STATES.optional,
    placeholder: "Last Name",
    type: "text",
    className: "last-name",
    order: 2,
    label: "Last Name"
  }
}

const PLACE_HOLDER = 'placeholder'
const LABEL = 'label'

const CustomFormFields = (props) => {
  const {fields , errors} = props
  const isRequired = (fieldState) => fieldState == CUSTOM_FORM_FIELD_STATES.required
  const isInvisible = (fieldState) => fieldState == CUSTOM_FORM_FIELD_STATES.invisible

  const getCustomFields = () => {
    let orderedFields = Object
      .keys(fields).sort((a, b) => {
        return fields[a].order - fields[b].order
      })
    const nameIdx = orderedFields.indexOf('name')
    const lastNameIdx = orderedFields.indexOf('last_name')

    // add last name for special name configuration
    if (nameIdx != -1 && lastNameIdx == -1) {
      orderedFields.splice(nameIdx + 1, 0, 'last_name')
    }

    return orderedFields
  }

  const translateSection = (section, key, config) => {
    const { shouldTranslate, getTranslation } = props
    if (shouldTranslate) {
      return getTranslation(`${key}_${section}`)
    }
    return config[section]
  }

  return (
    <div className="custom-form-input-fields">
      {
        getCustomFields().map((key) => {
          const config = fields[key] || FIELDS_CONFIG[key]
          const fieldState = (fields[config.field] || config).state
          const errorClassName = errors[config.field] || errors[key] ? 'error' : ''
          const component = TYPE_COMPONENT[config.type]
          const className = `${key} ${errorClassName} ${FIELDS_CONFIG[key] ? FIELDS_CONFIG[key].className : ""}`

          const placeholder = translateSection(PLACE_HOLDER, key, config)
          const label = translateSection(LABEL, key, config)

          return !isInvisible(fieldState) &&
            <div key={key} className="custom-form-field">
              <label>
                {label}
                {isRequired(fieldState) && <span className="required-asterix">*</span>}
              </label>
              {component == TYPE_COMPONENT[FORM_FIELD_TYPES.select] ?
              <Field
                key={key}
                className={className}
                name={key}
                fieldName={key}
                component={SelectionField}
                items={config.selection_values}
                tabIndex={TAB_INDEXES.CustomFormField} /> :
              <Field
                className={className}
                key={key}
                name={key}
                component={component}
                type={config.type}
                placeholder={placeholder}
                tabIndex={TAB_INDEXES.CustomFormField} />}
            </div>
        })
      }
    </div>
  )
}

CustomFormFields.propTypes = {
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  shouldTranslate: PropTypes.bool
}

CustomFormFields.defaultProps = {
  shouldTranslate: false,
  errors: {}
}

export default withTranslation(TRANSLATION_KEYS.customForm)(CustomFormFields)